var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0H0V30H45V0Z",
    fill: "#E2E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3111 3C13.0347 3 12 4.03472 12 5.31111V24.6889C12 25.9653 13.0347 27 14.3111 27H30.8444C32.1208 27 33.1556 25.9653 33.1556 24.6889V18.3778V9.75556L26.5778 3H26.5778H14.3111Z",
    fill: "#F25AA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5776 3L29.8665 6.37778L33.1554 9.75556H28.8887C27.6124 9.75556 26.5776 8.72084 26.5776 7.44444V3Z",
    fill: "#D11E73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.266 17.5981C28.2561 17.5981 28.8741 16.9309 28.8741 15.8636C28.8741 14.7962 28.2561 14.1291 27.266 14.1291L26.4233 14.1361V17.591L27.266 17.5981ZM25.356 18.525V13.2021H27.2871C28.846 13.2021 29.9415 14.2976 29.9415 15.8636C29.9415 17.4295 28.846 18.525 27.2871 18.525H25.356Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7494 13.2021L24.9193 18.525H23.7677L23.2199 17.1908H20.9869L20.4321 18.525H19.2734L21.4925 13.2021H22.7494ZM21.3661 16.2779H22.8477L22.1174 14.4802L21.3661 16.2779Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3304 18.581C15.7855 18.581 14.7041 17.4574 14.7041 15.8634C14.7041 14.2623 15.7855 13.1388 17.3304 13.1458C18.0607 13.1458 18.7138 13.4548 19.1843 13.9393L18.5031 14.6907C18.2573 14.3255 17.8009 14.0727 17.3234 14.0727C16.3684 14.0657 15.7715 14.7539 15.7715 15.8634C15.7715 16.9659 16.3684 17.6541 17.3234 17.6541C17.8852 17.6541 18.2503 17.3591 18.454 17.0782L19.1843 17.7875C18.7138 18.272 18.145 18.595 17.3304 18.581Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCad);
export default __webpack_public_path__ + "static/media/icon_cad.f357ecf6cc680f9b79cbdb59540e10a7.svg";
export { ForwardRef as ReactComponent };